import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { DataListParameter } from '@shared/interfaces/data-list-parameter.interface';
import {
  FindAllResponse,
  FindOneResponse,
} from '@shared/interfaces/response.Interface';
import {
  CategoryResponse,
  ProductInfoResponse,
  ProductResponse,
} from '../interface/product.interface';

const ROOT_API = environment.API_URL;

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  constructor(private readonly http: HttpClient) {}

  getProducts(dataListParameter: DataListParameter = {} as DataListParameter) {
    let param = '';
    if (dataListParameter.rows && dataListParameter.page) {
      param = param.concat(
        `?page=${dataListParameter.page}&limit=${dataListParameter.rows}`
      );
    }
    if (dataListParameter.sortBy) {
      param = param.concat('&' + dataListParameter.sortBy);
    }
    if (dataListParameter.filterObj) {
      param = param.concat('&' + dataListParameter.filterObj);
    }
    if (dataListParameter.filterRange) {
      param = param.concat('&' + dataListParameter.filterRange);
    }

    if (dataListParameter.searchQuery) {
      if (!dataListParameter.sortBy) {
        param = param.concat('?q=' + dataListParameter.searchQuery);
      } else {
        param = param.concat('&q=' + dataListParameter.searchQuery);
      }
    }
    return this.http.get<
      FindAllResponse<'products', Omit<ProductResponse, 'product_infos'>[]>
    >(`${ROOT_API}/products${param}`);
  }
  getProductCategories(paramString: string) {
    return this.http.get<
      FindAllResponse<'product_categories', CategoryResponse[]>
    >(`${ROOT_API}/product-categories${paramString}`);
  }
  getProduct(id: number) {
    return this.http.get<FindOneResponse<ProductResponse>>(
      `${ROOT_API}/products/${id}`
    );
  }
  getProductInfos(productId: number, params?: string) {
    return this.http.get<
      FindAllResponse<'product_infos', ProductInfoResponse[]>
    >(`${ROOT_API}/products/${productId}/infos?${params}`);
  }
}
